import type { ReactNode } from 'react'

/** A section is a name and a rule. The rule is the separation; no boxes are needed to say "new". */
export function SectionHeading({
  id,
  action,
  children,
}: {
  id: string
  /** Optional control that belongs to the section itself, e.g. a refresh. */
  action?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="mb-3 flex items-center gap-3">
      <h2 id={id} className="text-ui font-semibold text-ink">
        {children}
      </h2>
      <span aria-hidden="true" className="h-px flex-1 bg-line" />
      {action}
    </div>
  )
}
